import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.connector-section.permission-popup.title',
		defaultMessage: 'You must be a Jira admin to connect',
		description: 'The title of the dialog',
	},
	description: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.connector-section.permission-popup.description',
		defaultMessage: 'Contact your Jira admin to set up a source code management tool.',
		description: 'The sub title of the dialog',
	},
	buttonText: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.connector-section.permission-popup.button-text',
		defaultMessage: 'OK, got it',
		description: 'Label for the primary dialog button',
	},
});
